import axios from "axios";
import store from "../store/index";
import config from "../config";

export default {
  getEvents(context, success, error) {
    let id = store.state.user.id;
    axios({
      url: config.URLS.i5Scheduler + `events/user/${id}`,
      method: "GET"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  getEventfromID(context, success, error) {
    axios({
      url: config.URLS.i5Scheduler + "events/" + context.eventId,
      method: "GET"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  getTimeZones(context, success, error) {
    axios({
      url: config.URLS.i5Scheduler + "Scheduler/Timezones",
      method: "GET"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  createEvent(context, success, error) {
    axios({
      url: config.URLS.i5Scheduler + "events",
      data: context.addEventPayLoad,
      method: "POST"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  updateEvent(context, payload, id, success, error) {
    axios({
      url: config.URLS.i5Scheduler + "events/" + id,
      data: payload,
      method: "PUT"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  updateBasicEventDetails(context, payload, id, success, error) {
    axios({
      url: config.URLS.i5Scheduler + "events/" + id + "/basic",
      data: payload,
      method: "PUT"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  getExceptionData(context, id, eventDate, success, error) {
    axios({
      url:
        config.URLS.i5Scheduler +
        "events/" +
        id +
        "/slots?eventDate=" +
        eventDate,
      method: "GET"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  downloadReport(context, uri, success, error) {
    console.log("context", context);
    let id = store.state.user.id;
    axios({
      url:
        config.URLS.i5Scheduler + `events/bookings/export?${id}` + uri,
      method: "GET",
      responseType: "blob"
    })
      .then(response => {
        success(response);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  getReportData(context, uri, success, error) {
    let id = store.state.user.id;
    axios({
      url: config.URLS.i5Scheduler + `events/bookings/${id}?` + uri,
      method: "GET"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  updateExceptionData(context, id, eventDate, payload, success, error) {
    axios({
      url:
        config.URLS.i5Scheduler +
        "events/" +
        id +
        "/eventslot/" +
        eventDate,
      data: payload,
      method: "PUT"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  updateSettings(context, id, payload, success, error) {
    axios({
      url: config.URLS.i5Scheduler + "events/" + id + "/settings",
      data: payload,
      method: "PUT"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  syncAppointment(context, success, error) {
    axios({
      url:
        config.URLS.i5Scheduler +
        "events/appointment/" +
        context.syncingItemID +
        "/sync?referenceId=" +
        context.syncingReferenceID,
      method: "POST"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  deleteEvent(context, success, error) {
    axios({
      url:
        config.URLS.i5Scheduler +
        "events/appointment/" +
        context.deleteEvent.id +
        "/deleteandsync",
      method: "DELETE"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  copyandUpdateAppointments(context, payload, success, error) {
    axios({
      url:
        config.URLS.i5Scheduler +
        "events/" +
        context.eventId +
        "/eventslot/copyandupdate?eventSlotDates=" +
        context.copyToDatesAPI,
      data: payload,
      method: "PUT"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  }
};
